module.exports = __webpack_public_path__ + "static/media/SCAN_package_target.94c2c69e.svg";